// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-modules__spinner__khf0i","local":"Spinner-modules__local__Rd_Eq","show-keyframe":"Spinner-modules__show-keyframe__nkHKI"};